/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-01 16:18:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 11:37:35
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/Components/EditModal/General.tsx
 */
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { cloneDeep } from 'lodash';
import React from 'react';
import { Input, Select } from 'src/components/Antd';
import Slug from 'src/constrains/SlugInput';
import { useI18n } from 'src/hooks/useRouterChange';
import { hierarchyNameGenerator } from 'src/pages/SalesChannelCategory/PagesCategory/tools';
import { cancelRequest } from 'src/tools/server';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const GeneralModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onCancel,
    name: _name,
    urlSlug: _urlSlug,
    salesChannelUuid,
    parentUuid: _parentUuid,
    uuid: selfUuid,
    onDelete,
    onGetOptions,
    onSubmit,
    requestId,
    slugCheckingUrl,
    contentVersion,
    isSlugRequired = true,
    isPage = false,
  } = props;

  const [name, setName] = React.useState(_name || '');
  const [nameErr, setNameErr] = React.useState('');
  const [slugValid, setSlugValid] = React.useState(true);
  const [urlSlug, setUrlSlug] = React.useState(_urlSlug || '');
  const [parentUuid, setParentUuid] = React.useState(_parentUuid);
  const [parentErr, setParentErr] = React.useState(false);

  const [options, setOptions] = React.useState([]);
  const [slugError, setSlugError] = React.useState(false);
  React.useEffect(() => {
    if (onGetOptions) {
      onGetOptions({ setOptions });
    }
    return () => {
      cancelRequest(requestId);
    };
  }, []);
  const handleOnSubmit = () => {
    if (!name && !isPage) {
      setNameErr(getI18n('general.validNameError'));
      return;
    }
    if (!parentUuid) {
      setParentErr(true);
      return;
    }
    if (!slugValid) {
      return;
    }
    if (!urlSlug && isSlugRequired) {
      setSlugError(true);
      return;
    }
    onSubmit({
      urlSlug,
      name,
      parentUuid,
    });
  };
  return (
    <React.Fragment>
      <div className={css.container}>
        <ItemWrapper
          title={
            isPage
              ? getI18n('general.pageName')
              : `${getI18n('general.categoryName')}*`
          }
          rightSubTitle={
            isPage ? '' : getI18n('general.categorynameasSEOtitle')
          }
          rightPart={
            isPage ? null : (
              <CountWords count={(name || '').length} allCount={100} />
            )
          }>
          {isPage ? (
            name
          ) : (
            <Input
              error={!!nameErr}
              help={nameErr}
              size='large'
              maxLength={100}
              value={name}
              onChange={(e) => {
                setName(e);
                setNameErr('');
              }}
            />
          )}
        </ItemWrapper>
        {contentVersion && (
          <ItemWrapper title={getI18n('general.contentVersion')}>
            {contentVersion}
          </ItemWrapper>
        )}

        <ItemWrapper title={`${getI18n('general.parent')}*`}>
          <Select
            error={parentErr}
            value={parentUuid}
            onChange={(e) => {
              setParentUuid(e);
              setParentErr(false);
            }}
            optionsList={options.map((i) => {
              const { label, value, path } = i;
              const _path = cloneDeep(path);
              _path.shift();
              const _name = hierarchyNameGenerator(label, _path);

              return { label: _name, value };
            })}
            size='large'
          />
        </ItemWrapper>
        <Slug
          required
          value={urlSlug}
          displayDangerousNotice
          url={slugCheckingUrl}
          slugValid={slugValid}
          fixedParams={{
            salesChannelUuid: salesChannelUuid,
            uuid: selfUuid,
          }}
          onChange={({ slug, valid }) => {
            setSlugValid(valid);
            setUrlSlug(slug);
            if (slugError) setSlugError(false);
          }}
          customError={slugError}
          customHelper={getI18n('general.slugCannotbeEmpty')}
        />
      </div>
      <ModalFooter
        onDelete={onDelete}
        okText={getI18n('general.confirm')}
        onCancel={onCancel}
        onOk={handleOnSubmit}
      />
    </React.Fragment>
  );
};
export default GeneralModal;
